<template>
  <div class="detail">
    <h3>{{newData.title}}</h3>
    <h4>
      <span>信息来源：{{newData.source}}</span>
      <span>信息时间：{{newData.logintime.substr(0,10)}}</span>
      <!-- <span>阅读：202</span> -->
    </h4>
    <p v-html="newData.content"></p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newData:{}
    };
  },
  created() {
    // console.log(this.$route.query.id);
  },
  mounted() {
    console.log(this.ajax_content('getxinwenxiangqing',this.$route.query.id));
   this.newData = this.ajax_content('getxinwenxiangqing',this.$route.query.id).data;
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped>
.detail {
  display: block;
  margin: 0 auto;
  margin-top: 110px;
  padding-bottom: 60px;
  width: 1120px;
  height: auto;
  /* background-color: navy; */
}
.detail h3 {
  max-width: 1000px;
  margin: 0 auto;

  height: 40px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  text-align: center;
  color: #333333;
  letter-spacing: 5px;
}
.detail h4 {
  margin: 0 auto;
  padding: 40px 0;
  width: 1000px;
  height: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.detail h4 span {
  display: block;
  width: auto;
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 20px;
  color: #999999;
  letter-spacing: 2px;
}
.detail p {
  text-indent: 2em;

  width: 1120px;
  height: auto;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 52px;
  color: #666666;
}
</style>
